import { AppDispatch } from '../../store'
import { etlActions } from '../../reducers/etl'
import {
  EtlFileMappings,
  EtlFileCharacteristic,
  EtlQuestion,
  EtlValueMapping,
  EtlCharValueMapping,
} from '../../../shared/model/models'

export const changeCurrentStep = (currentStep: number) => (dispatch: AppDispatch) => {
  dispatch(etlActions.setCurrentStep(currentStep))
}

export const changeEtlFileMappings =
  (fileMappings: Record<string, EtlFileMappings>) => (dispatch: AppDispatch) => {
    dispatch(etlActions.setEtlFileMappings(fileMappings))
  }

export const startNewEtl = () => (dispatch: AppDispatch) => {
  dispatch(etlActions.resetEtl())
}

export const updateFileCharacteristics = (value: string | null, id: number, type: 'file' | 'column') => (dispatch: AppDispatch)=> {
  dispatch(etlActions.updateFileCharacteristics({ id, value, type }))
}

export const setEtlValueMappings = (mappings: EtlCharValueMapping[]) => (dispatch: AppDispatch) => {
  dispatch(etlActions.setEtlValueMappings(mappings))
}

export * from './thunk'
